import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { postData } from '../../Services/apiService.js';  // Import the postData function
import { apiUrl } from '../../config/api.js';
import { useNavigate } from 'react-router-dom';
import "./VerifyRegistration.css";

const VerifyRegistration = () => {
    const { transactionID, Fname, ContactNo, EmailID } = useParams(); // Get the Transaction ID from URL
    const [email, setEmail] = useState(EmailID); // Example email, replace with actual data
    const [otp, setOtp] = useState('');
    const [isPaymentVerified, setIsPaymentVerified] = useState(false);
    const [receiptData, setReceiptData] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {

        const handleSubmitOtp = async (e) => {
        
            // Logic to send OTP
           // e.preventDefault();
            
            const body = "";
    
            try {
                  
                initiatePayment();
    
            } catch (error) {

            }
    
        };


        handleSubmitOtp(); // Call the function to send OTP
    }, [transactionID, email]); // Dependencies for the useEffect


    

    const initiatePayment = async () => {
        const body = "";
        try {
            // Call your backend API to create Razorpay order
            const data = await postData(apiUrl('createorder/'+transactionID), body);
         console.log(data[0]);
            const { id: order_id, amount, currency, Status } = data[0];
            console.log(Status);
            if (Status === "Already Paid") {
                navigate(`/`);
                console.log("abcd efg hi jkl");
            }
            else if (Status === "Free") {
                console.log(data[0]);
                setReceiptData(data[0]);
                   setIsPaymentVerified(true);
            
            } else {

            // Options for Razorpay payment
            const options = {
                key: "rzp_live_1KBN81V4vtMQBt",
                amount: amount,
                currency: currency,
                order_id: order_id,
                name: "Thakur Capital",
                description: "Purchase Description",
                handler: function (response) {
                    const { razorpay_payment_id, razorpay_order_id, razorpay_signature } = response;
                    
                    verifypayment(razorpay_payment_id, razorpay_order_id, razorpay_signature);



                    // Handle success
                    alert("Payment successful: " + response.razorpay_payment_id );
                    // Optionally, save the payment ID to your server for reference
                },
                prefill: {
                    name: Fname,
                    email: EmailID,
                    contact: ContactNo
                }
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open(); // Open Razorpay Checkout
        }
        } catch (error) {
            console.error("Failed to initiate payment:", error);
        }
    };

    const verifypayment = async (razorpay_payment_id, razorpay_order_id, razorpay_signature) => {
        const body = "";
        try {
            // Call your backend API to create Razorpay order
            const recipt = await postData(apiUrl('verifypayment/'+razorpay_payment_id+'/'+razorpay_order_id+'/'+razorpay_signature+'/'+transactionID), body);
         console.log(recipt[0]);
         setReceiptData(recipt[0]);
            setIsPaymentVerified(true);
           
        } catch (error) {
            console.error("Payment verification faild:", error);
        }

    };

   return (

<div className="success-page">

    {isPaymentVerified && receiptData && (

        <div className="container py-5">

            {/* ================= Success Banner ================= */}

            <div className="success-banner">

    <div className="success-top-badge">

        <span>🎉 REGISTRATION CONFIRMED</span>

    </div>

    <div className="success-check">

        ✓

    </div>

    <h1>

        Registration Successful

    </h1>

    <h4>

        Congratulations {receiptData.Fname}!

    </h4>

    <p>

        Your seat has been successfully reserved for

    </p>

    <h2 className="course-title-success">

        {receiptData.CourseTitle}

    </h2>

   

</div>

            {/* ================= Main Content ================= */}

            <div className="row g-4 mt-2">

                {/* LEFT CARD */}

                <div className="col-lg-5">

                    <div className="course-summary-card">

                        <div className="course-badge">

                            PREMIUM COURSE

                        </div>

                        <h2>

                            {receiptData.CourseTitle}

                        </h2>

                        <p className="course-subtitle">

                            {receiptData.CourseSubTitle}

                        </p>

                        <hr />

                        <div className="course-info">

                            <div className="info-row">

                                <span>👨 Trainer</span>

                                <strong>{receiptData.CourseBy}</strong>

                            </div>

                            <div className="info-row">

                                <span>📅 Date</span>

                                <strong>{receiptData.CourseDate}</strong>

                            </div>

                            <div className="info-row">

                                <span>🕒 Time</span>

                                <strong>{receiptData.Time}</strong>

                            </div>

                            <div className="info-row">

                                <span>🌐 Language</span>

                                <strong>{receiptData.Language}</strong>

                            </div>

                            <div className="info-row">

                                <span>📍 Location</span>

                                <strong>{receiptData.CourseLocation}</strong>

                            </div>

                            <div className="info-row">

                                <span>💰 Course Fee</span>

                                <strong>

                                    {Number(receiptData.Fees) === 0
                                        ? "FREE"
                                        : `₹ ${Number(receiptData.Fees).toLocaleString("en-IN")}`}

                                </strong>

                            </div>

                        </div>

                    </div>

                </div>

                {/* RIGHT CARD */}

                <div className="col-lg-7">

                    <div className="participant-card">

                        <h3>

                            Participant Details

                        </h3>

                        <div className="participant-header">

                            <div className="participant-avatar">

                                {receiptData.Fname.charAt(0)}

                            </div>

                            <div>

                                <h4>

                                    {receiptData.Fname} {receiptData.Mname} {receiptData.Lname}

                                </h4>

                                <span>

                                    Registered Participant

                                </span>

                            </div>

                        </div>

                        <hr />

                        <div className="participant-info">

                            <div className="info-row">

                                <span>📞 Mobile</span>

                                <strong>

                                    {receiptData.ContactNo}

                                </strong>

                            </div>

                            <div className="info-row">

                                <span>✉ Email</span>

                                <strong>

                                    {receiptData.EmailID}

                                </strong>

                            </div>

                            <div className="info-row">

                                <span>🆔 Transaction</span>

                                <strong>

                                    {transactionID}

                                </strong>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

{/* ================= Payment & Next Steps ================= */}

<div className="row g-4 mt-3">

    {/* Payment Status */}

    <div className="col-lg-6">

        <div className="payment-card">

            <div className="payment-header">

                <h3>💳 Payment Status</h3>

                <span
                    className={
                        Number(receiptData.Fees) === 0
                            ? "badge bg-info"
                            : "badge bg-success"
                    }
                >

                    {Number(receiptData.Fees) === 0
                        ? "FREE REGISTRATION"
                        : "PAYMENT SUCCESS"}

                </span>

            </div>

            <hr />

            <div className="info-row">

                <span>Payment Status</span>

                <strong className="text-success">

                    {receiptData.PaymentStatus}

                </strong>

            </div>

            <div className="info-row">

                <span>Amount</span>

                <strong>

                    {Number(receiptData.Fees) === 0
                        ? "FREE"
                        : `₹ ${Number(receiptData.Fees).toLocaleString("en-IN")}`}

                </strong>

            </div>

            <div className="info-row">

                <span>Transaction ID</span>

                <strong>

                    {transactionID}

                </strong>

            </div>

        </div>

    </div>

    {/* What's Next */}

    <div className="col-lg-6">

        <div className="next-card">

            <h3>

                🚀 What Happens Next?

            </h3>

            <hr />

            <ul className="next-list">

                <li>

                    ✅ Confirmation email has been sent.

                </li>

                <li>

                    ✅ WhatsApp updates will be shared.

                </li>

                <li>

                    ✅ Zoom meeting link will be shared before class.

                </li>

                <li>

                    ✅ Please join 10 minutes before the session.

                </li>

                <li>

                    ✅ Keep your notebook ready.

                </li>

            </ul>

        </div>

    </div>

</div>

<div className="trust-strip mt-5">

    <div>

        🔒 Secure Registration

    </div>

    <div>

        📧 Confirmation Email Sent

    </div>

    <div>

        📱 WhatsApp Updates

    </div>

    <div>

        🎓 Certificate Available

    </div>

</div>

{/* ================= Buttons ================= */}

<div className="text-center mt-5">

    

    <button

        className="btn btn-outline-primary btn-lg px-5"

        onClick={() => navigate("/")}

    >

        🏠 Back To Home

    </button>

</div>

<div className="celebration-card mt-5">

    <h3>

        🎯 You're All Set!

    </h3>

    <p>

        We are excited to have you in this learning journey.

        Keep checking your WhatsApp and Email for session updates.

    </p>

</div>
        </div>

    )}

</div>

);
};

export default VerifyRegistration;
